<app-image-uploader
  [data]="imageConfig"
  [bg]="bgimage"
  (images)="buttonImage($event)"
  (imageSet)="buttonImageSet($event)"
></app-image-uploader>
